module.exports = __webpack_public_path__ + "static/ec-baseline-mobile-83d7fd3d426e4786db2566967932ecd8.png";